import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
  MutationCache,
} from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { flagIfAuthError } from './components/ResetBanner'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1 },
    mutations: { retry: 0 },
  },
  queryCache: new QueryCache({ onError: flagIfAuthError }),
  mutationCache: new MutationCache({ onError: flagIfAuthError }),
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
